import React from 'react';
import { Link } from 'gatsby';
import '../../styles/scss/style.scss';

export const Hero2 = () => {
  return (
    <div className="feature feature-2" style={{ marginTop:"10rem" }}>
        <h1 className="text-center feature__lead mb-5">Create an awesome <strong>landing</strong>, <strong>product</strong>, <strong>about page</strong>, or <strong>agency</strong> website with our pre-designed templates.</h1>
      <div className="feature__wrap animated fadeInUp">
          <img
            src={require('../../components/images/loopcreate1.png')}
            alt="loop design ui kit"
            className="feature__img"
          />
        </div>
    </div>
  );
};
